import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { REPEAT_INTERVAL, REPEAT_STATUS } from 'customer-data-objects/task/TaskPropertyNames';
import { useMemo } from 'react';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { TABLE_PROPERTIES } from '../../constants/properties';
import { RepeatStatusOptions } from '../../constants/repeatingTasks';
import { useMergeTaskProperties } from '../../hooks/properties';
import RepeatIntervalText from './RepeatIntervalText';
import getIn from 'transmute/getIn';
import once from 'transmute/once';
import toJS from 'transmute/toJS';
import { jsx as _jsx } from "react/jsx-runtime";
const getRepeatStatusLabels = once(propertyDefinitionOptions => {
  return propertyDefinitionOptions.reduce((acc, option) => {
    if (!option.value || !option.label) {
      return acc;
    }
    return Object.assign(acc, {
      [option.value]: option.label
    });
  }, {});
});
export default function TaskRepeatStatusCell({
  original: cdtTask
}) {
  const {
    loading,
    properties
  } = useMergeTaskProperties(TABLE_PROPERTIES);
  const propertyDefinitionOptions = toJS(getIn([REPEAT_STATUS, 'options'], properties)) || [];
  const repeatStatus = getProperty(cdtTask, REPEAT_STATUS);
  const repeatInterval = getProperty(cdtTask, REPEAT_INTERVAL);
  const isRepeating = Boolean(repeatInterval);
  const repeatIntervalJS = useMemo(() => isRepeating ? repeatInterval.toJS() : null, [isRepeating, repeatInterval]);
  if (loading || !repeatStatus) {
    return '--';
  }
  if (repeatStatus === RepeatStatusOptions.REPEATING) {
    // Handle edge case where task is edited to be non-repeating
    // Repeat status has not been updated and is still REPEATING, but repeat interval property is null
    return isRepeating ? /*#__PURE__*/_jsx(RepeatIntervalText, {
      repeatInterval: repeatIntervalJS
    }) : '--';
  }
  const repeatStatusToLabel = getRepeatStatusLabels(propertyDefinitionOptions);
  return /*#__PURE__*/_jsx(UITruncateString, {
    children: repeatStatusToLabel[repeatStatus] || '--'
  });
}